import * as components from './components'

export default [
  {
    path: '/job/create',
    component: components.CreateEditJob,
    name: 'jobCreate'
  },
  {
    path: '/job/:uuid/edit',
    component: components.CreateEditJob,
    name: 'jobEdit',
    props: true
  },
  {
    path: '/job/:uuid/home',
    component: components.JobHome,
    name: 'jobHome',
    props: true
  },
  {
    path: '/job/:uuid/applicants',
    component: components.JobApplicants,
    name: 'jobApplicants',
    props: true
  },
  {
    path: '/job/:uuid/viewers',
    component: components.JobViewers,
    name: 'jobViewers',
    props: true
  },
  {
    path: '/job/:uuid/reports',
    component: components.JobReports,
    name: 'jobReports',
    props: true
  },
  {
    path: '/employer/:uuid/suborg/upload',
    component: components.SubOrgUpload,
    name: 'subOrgUpload',
    props: true
  },
  {
    path: '/employer/:uuid/suborg/create',
    component: components.CreateEditSubOrg,
    name: 'subOrgCreate',
    props: true
  },
  {
    path: '/employer/:uuid/suborg/:subOrgId/edit',
    component: components.CreateEditSubOrg,
    name: 'subOrgEdit',
    props: true
  },
  {
    path: '/employer/:uuid/details/edit',
    component: components.EditEmployerDetails,
    name: 'employerDetailsEdit',
    props: true
  },
  {
    path: '/employer/:uuid/details',
    component: components.EmployerDetails,
    name: 'employerDetails',
    props: true
  },
  {
    path: '/employer/institution/:uuid/details',
    component: components.EmployerInstitutionDetails,
    name: 'employerInstitutionDetails',
    props: true
  },
  {
    path: '/job/applications',
    component: components.MyJobApplications,
    name: 'myJobApplications'
  },
  {
    path: '/job/upload',
    component: components.JobUpload,
    name: 'jobUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/job/routes.js